import { Icon } from "armstrong-react";
import React from "react";
import { ReactRouterLink } from "../../../core/atoms";
import { isBrowser } from "../../../core/detection";

import "./locationNavigation.scss";

interface LocationNavigationItem {
  to: string;
  title: string;
  onlyActiveOnIndex?: boolean;
}

interface Props {
  items: LocationNavigationItem[];
  selectOption?: string;
  onSelectChange?(route): void;
}

interface State {
  selectOption: string;
}

export class LocationNavigation extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const matchingNavItem = this.getMatchingNavItem();

    this.state = {
      selectOption: matchingNavItem,
    };
  }

  public render() {
    const { items } = this.props;
    const { selectOption } = this.state;
    return (
      <div className="location-navigation">
        <nav className="location-navigation--desktop width-wrapper">
          {items.map((item, index) => (
            item.to ?
              <ReactRouterLink
                key={index}
                to={item.to}
                activeClassName={"active-nav"}
                onlyActiveOnIndex={item.onlyActiveOnIndex}
                data-title={item.title}
                onClick={() => this.handleLinkClick(item)}
                scrollOnTransition={false}
              >
                {item.title}
                <div className="accent-circle-overlay"></div>
              </ReactRouterLink>
              // only used for the colour tab in admin location image gallery
              : <a href="#undefined" key={Math.random()}>{item.title}<div className="accent-circle-overlay"></div></a>
          ))}
        </nav>
        <div className="location-navigation--mobile">
          <select onChange={this.handleSelectChange} value={selectOption}>
            {items.map((item, index) => (
              <option key={index} value={item.title}>{item.title}</option>
            ))}
          </select>
          <Icon icon={Icon.Icomoon.arrowDown3} />
        </div>
      </div>
    );
  }

  private handleSelectChange = (event) => {
    const matchingNavItem = this.props.items.find(item => item.title === event.target.value);

    if (matchingNavItem) {
      this.setState({
        selectOption: matchingNavItem.title,
      }, () => {
        if (this.props.onSelectChange) {
          this.props.onSelectChange(matchingNavItem.to);
        }
      });
    }
  }

  private handleLinkClick = (item) => {
    this.setState({
      selectOption: item.title,
    });
  }

  private getMatchingNavItem() {
    if (!isBrowser() || !this.props.items || this.props.items.length === 0) {
      return;
    }

    const pathToMatch = isBrowser() ? window.location.pathname : undefined;

    const matchingNavItem = this.props.items.find(item => item.to === pathToMatch);

    if (matchingNavItem) {
      return matchingNavItem.title;
    }

    return this.props.items[0].title;
  }
}
